module.exports = __webpack_public_path__ + "img/angry.a41b4494.png";